__webpack_public_path__ = window.publicPath;  // eslint-disable-line no-undef

import App from 'Components/App.vue';
import appFactory from 'Libs/appFactory';

const initialState = window.__INITIAL_STATE__;
const { app } = appFactory(App, initialState);

app.$mount('#app', true);
